import { Box, Typography, Button } from '@mui/material';

import mobileAppImage from '../../assets/img/mobileLanding/technology-img1.png';
import webAppImage from '../../assets/img/mobileLanding/technology-img2.png';
import ecommerceImage from '../../assets/img/mobileLanding/technology-img3.png';
import { E_COMMERCE_STYLES } from 'components/ECommerce/config';
import { paths } from 'routes/routes/paths';
import { Link } from 'react-router-dom';

function Solutions({ type }: { type: string }) {
    const solutions = [
        {
            id: 1,
            title: 'Mobile App Development',
            seoTitle: 'Mobile App Development Company Kerala - Android & iOS',
            description: (
                <>We build end-to-end mobile apps from idea and UX to Android & iOS development, testing, and launch. Our <b>Flutter apps</b> are <b>fast, scalable, user-friendly</b>, and powered by <b>secure APIs</b> and <b>cloud-ready architecture.</b></>
            ),
            image: mobileAppImage,
        },
        {
            id: 2,
            title: <>Custom <br /> Web Applications</>,
            seoTitle: 'Custom Web Application Development Kerala',
            tagline: 'Tailored to your Business',
            description: (
                <>We design and build custom web apps and internal tools that <b>streamline operations</b>, <b>connect departments</b>, and <b>scale with your business</b>, built around your real workflow, secure, performance-optimised, and easy for your team to use.</>
            ),
            image: webAppImage,
        },
        {
            id: 3,
            title: <>Enterprise <br /> E-commerce <br /> Solutions</>,
            seoTitle: 'Enterprise eCommerce & Shopify Developers Kerala',
            tagline: 'Built to Scale Your Business',
            description: (
                <>We build enterprise e-commerce platforms with mobile apps on a <b>microservices</b> architecture, integrated with ERP, inventory, and CRM. supporting B2C & B2B, GCC-ready with Arabic, & multi-currency. Fast, flexible, and <b>built for long-term growth.</b></>
            ),
            image: ecommerceImage,
            learnMoreLink: paths.public.eCommerce,
        },
    ];

    return (
        <Box
            sx={{
                backgroundColor: 'white',
                position: 'relative',
                ...(type === 'web' ? { zIndex: 1 } : {}),
            }}
        >
            <Box
                sx={{
                    background: 'linear-gradient(0deg, #EBEDF0 0%, #EBEDF0 71.12%, rgba(235, 237, 240, 0) 100%)',
                    ...(type === 'web' ? {
                        position: 'relative',
                        zIndex: 1,
                        borderRadius: '0 0 50px 50px',
                        cornerShape: 'squircle',
                        pb: 3,
                    } : {
                        borderRadius: '0 0 25px 25px',
                    }),
                }}
            >
                {/* Solution Cards */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: type === 'web' ? 'row' : 'column',
                        gap: type === 'web' ? 2 : 6,
                        background: 'transparent',
                        pb: 2,
                        ...(type === 'web' ? {
                            maxWidth: E_COMMERCE_STYLES.container.maxWidthWeb,
                            margin: E_COMMERCE_STYLES.container.mx,
                            padding: 4,
                            pt: 0,
                        } : {
                            borderRadius: '0 0 25px 25px',
                        }),
                    }}
                >
                    {solutions.map((solution, index) => (
                        <Box key={solution.id} sx={{ position: "relative" }}>
                            <Box
                                sx={{
                                    background: type === 'mobile' ? 'linear-gradient(180deg, #EBEDF0 0%, #EBEDF0 71.12%, rgba(235, 237, 240, 0) 100%)' : '',
                                    height: "300px",
                                }}
                            />
                            <Box padding={type === 'web' ? 0 : 2} pb={0} sx={{ marginTop: "-16rem" }}>
                                {/* Heading */}
                                <Box
                                    sx={type === 'web' ? { height: '200px', margin: "auto", display: "flex", justifyContent: "center", alignItems: "center" } : {}}
                                >
                                    <Typography
                                        variant="h5"
                                        className='font-satoshi-regular'
                                        sx={{
                                            background: 'linear-gradient(180deg, #54648D 0%, #59719E 100%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            backgroundClip: 'text',
                                            fontSize: '24px',
                                            textAlign: 'center',
                                            lineHeight: 1.4,
                                            mb: 0,
                                        }}
                                    >
                                        {index === 0 && (
                                            <>
                                                Turn your idea or process <br /> into a{' '}
                                                <Box component="span" className='font-satoshi-bold'>
                                                    user-friendly mobile app
                                                </Box> {' '}
                                                your customers and team{' '}
                                                <Box component="span" className='font-satoshi-bold'>
                                                    actually enjoy using.
                                                </Box>
                                            </>
                                        )}
                                        {index === 1 && (
                                            <>
                                                Is your business process{' '} <br />
                                                <Box component="span" className='font-satoshi-bold'>
                                                    too unique
                                                </Box>
                                                {' '}for
                                                <br />
                                                <Box component="span" className='font-satoshi-bold'>
                                                    ready-made software?
                                                </Box>
                                            </>
                                        )}
                                        {index === 2 && (
                                            <>
                                                Want to take your business to{' '}<br />
                                                <Box component="span" className='font-satoshi-bold'>
                                                    Next Level?
                                                </Box>
                                            </>
                                        )}
                                    </Typography>
                                </Box>
                                {/* Solution Card */}
                                <Box
                                    sx={{
                                        backgroundColor: 'white',
                                        border: '1px solid transparent',
                                        backgroundImage: 'linear-gradient(white, white), linear-gradient(180deg, #AAC639 0%, #45D662 100%)',
                                        backgroundOrigin: 'border-box',
                                        backgroundClip: 'padding-box, border-box',
                                        borderRadius: '45px',
                                        cornerShape: 'squircle',
                                        padding: '40px 14px',
                                        textAlign: 'center',
                                        zIndex: 2,
                                        position: "relative",
                                        ...(type === 'web' ? {
                                            height: '500px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                        } : {}),
                                    }}
                                >
                                    {/* Content Container */}
                                    <Box sx={{ flex: type === 'web' ? '1 1 auto' : 'none' }}>
                                        {/* Title */}
                                        <Typography
                                            variant="h3"
                                            className='font-satoshi-bold'
                                            sx={{
                                                background: 'linear-gradient(90deg, #3D60C9 0%, #AD59E5 100%)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                backgroundClip: 'text',
                                                fontSize: type === 'web' ? '28px' : '30px',
                                                lineHeight: 1.2,
                                                mb: 0.5,
                                                px: 2
                                            }}
                                        >
                                            {solution.title}
                                        </Typography>

                                        {/* Tagline */}
                                        {solution.tagline && (
                                            <Typography
                                                variant="h6"
                                                className='font-satoshi-semibold'
                                                sx={{
                                                    color: "#271A6F",
                                                    fontSize: '16px',
                                                    mb: 1,
                                                }}
                                            >
                                                {solution.tagline}
                                            </Typography>
                                        )}


                                        {/* Placeholder Image */}
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            position: 'relative',
                                            zIndex: 1,
                                        }}>
                                            <img src={solution.image} alt={solution.seoTitle} title={solution.seoTitle} />
                                        </Box>

                                        {/* Description */}
                                        <Typography
                                            variant="body1"
                                            className='font-satoshi-regular'
                                            sx={{
                                                background: 'linear-gradient(180deg, #3D710F -80.79%, #677ECB 151.65%)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                backgroundClip: 'text',
                                                fontSize: type === 'web' ? '14px' : '16px',
                                                lineHeight: 1.7,
                                                // mb: type === 'web' ? 2 : 4,
                                                px: 1,
                                                mt: -2,
                                                position: 'relative',
                                                zIndex: 2,
                                            }}
                                        >
                                            {solution.description}
                                        </Typography>
                                    </Box>

                                    {/* Learn More Button */}
                                    {solution?.id === 3 &&
                                        <Link to={solution?.learnMoreLink || ''}>
                                            <Button
                                                variant="outlined"

                                                className='font-satoshi-bold'
                                                sx={{
                                                    width: "fit-content",
                                                    margin: "auto",
                                                    background: '#F0FBFE',
                                                    color: '#3C73A4',
                                                    fontSize: '16px',
                                                    padding: '12px 48px',
                                                    borderRadius: '50px',
                                                    border: '1px solid transparent',
                                                    backgroundImage: 'linear-gradient(#F0FBFE, #F0FBFE), linear-gradient(180deg, #39C664 0%, #45D1D6 100%)',
                                                    backgroundOrigin: 'border-box',
                                                    backgroundClip: 'padding-box, border-box',
                                                    textTransform: 'none',
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': {
                                                        background: '#E5F5FA',
                                                        backgroundImage: 'linear-gradient(#E5F5FA, #E5F5FA), linear-gradient(180deg, #39C664 0%, #45D1D6 100%)',
                                                        backgroundOrigin: 'border-box',
                                                        backgroundClip: 'padding-box, border-box',
                                                        boxShadow: '0 4px 12px rgba(57, 198, 100, 0.3)',
                                                    },
                                                }}
                                            >
                                                Learn More
                                            </Button>
                                        </Link>
                                    }
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>

        </Box >
    );
}

export default Solutions;
